<template functional>
    <div class="container main layout-with-aside" :class="data.staticClass">
        <div class="row">
            <div
                class="col-12 layout-with-aside__desktop-left"
                :class="{ 'col-lg-8': slots().aside, 'order-2 order-lg-1': props.reorderMobile }"
            >
                <slot name="main"> </slot>
            </div>
            <div v-if="slots().aside" class="col-12 col-lg-4" :class="{ 'order-1 order-lg-2': props.reorderMobile }">
                <aside
                    class="layout-with-aside__aside"
                    :class="{
                        'layout-with-aside__aside--over-teaser': props.overTeaser,
                        'layout-with-aside__aside--sticky-aside': props.stickyAside
                    }"
                >
                    <slot name="aside"> </slot>
                </aside>
            </div>
        </div>

        <slot name="after"></slot>
    </div>
</template>

<script>
export default {
    name: 'LayoutWithAside',
    props: {
        overTeaser: Boolean,
        reorderMobile: Boolean,
        stickyAside: Boolean
    }
};
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '@/styles/variables';
@use '@/styles/mixins';

.layout-with-aside {
    &__desktop-left {
        background-color: var(--body-bg);
    }

    &__aside {
        @include mixins.desktop-only {
            border: 1px solid var(--border-color);
            background-color: var(--aside-darker-bg);

            z-index: map.get(variables.$z-indices, 'tooltips');
            border-radius: 0 0 4px 4px;
            box-shadow: 0 12px 24px 0 hsla(0, 0%, 0%, 0.07);

            &--sticky-aside {
                position: sticky;
                top: var(--product-select-sticky-top);
            }
        }

        @media screen {
            &--over-teaser {
                margin-top: -130px;
            }
        }
    }
}
</style>
